import { IConversation } from './../../models/IConversation';
export function getNextConversationName(
    conversations: IConversation[],
    curConversationName: string
)
    : string | null {
    for (var i = 0; i < conversations.length; i++) {
        if (conversations[i].name === curConversationName) {
            return conversations[i].name;
        }
    }
    if (conversations.length > 0) {
        return conversations[0].name;
    }
    return null;
}
